<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] flex flex-col">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Tabela de Preço</h3>
            <AppButton class=" self-end text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="close" :width=23 :height=23 /> 
        </div>

        <div class="flex gap-2 w-full">
            <div class=" left-input-field flex flex-col gap-2">
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">ID:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="fornecedor" v-model="fornecedor.id" placeholder="fornecedor">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="versao">Versão:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="versao" v-model="model.versao" placeholder="Versão">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.data" placeholder="Data">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Validade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.validade" placeholder="Validade">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Valor Rapel:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="double" id="data" v-model="model.Valor_Rapel" placeholder="Valor Rapel">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Desc. Rapel:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="double" id="data" v-model="model.Desconto_Rapel" placeholder="Desconto Rapel">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.status" placeholder="Status">
                </div>
            </div>

            <div class="right w-[40vw] flex flex-col gap-2 rounded-[10px] bg-[var(--fundoApp)] p-4 ">
                <h3 class="text-[var(--titulo)]">Item Tabela Preço</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Tabela Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_tabela_precos_model.tabela_id" placeholder="Tabela Id">

                    <label class="min-w-[6.5rem]" for="data">Produto Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_tabela_precos_model.produto_id" placeholder="Produto Id">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Preço:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_tabela_precos_model.preco" placeholder="Preço">

                    <label class="min-w-[6.5rem]" for="data">Preço Medio:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_tabela_precos_model.preco_medio" placeholder="Preço Medio">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_tabela_precos_model.status" placeholder="Status">
                </div>



                <h3 class="text-[var(--titulo)]">Quantidade Desconto</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Tabela Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.tabela_id" placeholder="Tabela Id">

                    <label class="min-w-[6.5rem]" for="data">Equip Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.equipamento_id" placeholder="Equipamento Id">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Quantidade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.quantidade" placeholder="Quantidade">

                    <label class="min-w-[6.5rem]" for="data">Desconto:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.desconto" placeholder="Desconto">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.status" placeholder="Status">
                </div>




                <h3 class="text-[var(--titulo)]">Desconto Rapel</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Tabela Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.tabela_id" placeholder="Tabela Id">

                    <label class="min-w-[6.5rem]" for="data">Equip Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.equipamento_id" placeholder="Equipamento Id">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Valor:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.Valor_Rapel" placeholder="Valor">

                    <label class="min-w-[6.5rem]" for="data">Desconto:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.desconto" placeholder="Desconto">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="desc_qtd_item_tabela_precos_model.status" placeholder="Status">
                </div>

                <AppTable :visibility="true" :show="true" :table_data="produtos" table_title="Produtos"
                  @row-clicked="select_produto" @close="close_table" :show_multiSelect="false" />
                
            </div>

        </div>

    </div>

</template>


<script>
    import axios from 'axios';
    import AppButton from '@/components/button.vue'
    import AppTable from '@/components/tables/table.vue'
    export default {
        name: 'preco',
        components: {
            AppButton,
            AppTable
        },
        props: {
          fornecedor: {
              type: Object,
              default: {}
            },  
        },
        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                model: {
                    fornecedor: this.fornecedor.nome,
                    versao: this.fornecedor.versao,
                    data: this.fornecedor.data,
                    validade: '',
                    Valor_Rapel: 0,
                    Desconto_Rapel: 0,
                    status: this.fornecedor.status,
                },
                item_tabela_precos_model:{
                    tabela_id: 0,
                    produto_id: 0,
                    preco: 0,
                    preco_medio: 0,
                    status: 0,
                },
                desc_qtd_item_tabela_precos_model:{
                    tabela_id: 0,
                    equipamento_id: 0,
                    quantidade: 0,
                    desconto: 0,
                    status: 0,
                },
                desc_rap_item_tabela_precos_model:{
                    tabela_id: 0,
                    equipamento_id: 0,
                    quantidade: 0,
                    desconto: 0,
                    status: 0,
                },
                moedas:[],
                produtos:[],
                
            };
        },
        async created() {
            this.moedas= await this.select_all(`${this.baseURl}/api/v1/produto/`);
            this.produtos= await this.select_all(`${this.baseURl}/api/v1/produto/`);
            
            
        },
        methods: {
            close() {
                this.$emit('close');
            },
            async create(data, url) {
              try {
                  const res = await axios.post(url, data);
                  return res.data.data;
              } catch (error) {
                  console.error('Error getting data:', error);
              }
            },
  
        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
    
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
    
            } catch (error) {
                console.error('Error getting data:', error);
            }
    
        },
    
        async update(url, data) {
    
            try {
                const res = await axios.put(url, data);
                console.log('Data successfully updated:', res.data);
                return res.data.data;
    
            } catch (error) {
                console.error('Error posting data:', error);
            }
        },
    
        async remove(url) {
            // console.log("Data:", data.id)
            try {
                await axios.delete(url);
                return true;
            } catch (error) {
                console.error('Error deleting data:', error);
            }
        },
            
        }
    }

</script>



<style scoped>


</style>